module.exports = __webpack_public_path__ + "static/media/thit-nuong-mat-ong.a005a810.jpg";